/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { RetrieveDocumentGenerationJob } from './RetrieveDocumentGenerationJob';
export type BulkGenerationTargetConflict = {
  error: string;
  code: BulkGenerationTargetConflict.code;
  company_id: number;
  company_measurement_date_id: number | null;
  expected_cap_table_id: number | null;
  created_jobs: Array<RetrieveDocumentGenerationJob>;
};
export namespace BulkGenerationTargetConflict {
  export enum code {
    GENERATION_TARGET_CHANGED = 'generation_target_changed',
  }
}

